import type {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch
} from 'react-hook-form';
import {
  StyledCard,
  StyledInput
} from '@bo-components/common/StyledComponents';
import type { GameModeData } from '@library/types/gameModes';
import { MultiSelect } from '@library/components/selects/multiSelect/MultiSelect';
import type { SelectOptions } from '@library/types/utils';

interface GameModesDetailsInputsProps {
  errors: FieldErrors;
  isReadOnly: boolean;
  isEditMode: boolean;
  register: UseFormRegister<GameModeData>;
  setValue: UseFormSetValue<GameModeData>;
  watch: UseFormWatch<GameModeData>;
  gameTypeOptions: SelectOptions;
  allowedStatesOptions: SelectOptions;
}

export const GameModesDetailsInputs = ({
  errors,
  isReadOnly,
  isEditMode,
  register,
  setValue,
  watch,
  gameTypeOptions,
  allowedStatesOptions
}: GameModesDetailsInputsProps) => {
  const gameTypes = watch('gameTypes') || [];
  const allowedStates = watch('allowedStates') || [];

  return (
    <form>
      <div className="flex gap-4">
        <StyledCard title="General Information">
          <StyledInput
            error={errors.name?.message as string}
            label="Name"
            name="name"
            readOnly={isReadOnly}
            register={register}
            required={isEditMode}
          />
          <StyledInput
            error={errors.gameTypes?.message as string}
            label="Game Types"
            name="gameTypes"
            readOnly={isReadOnly}
            register={register}
          >
            <MultiSelect
              allowSelectNone={false}
              defaultEmpty
              allOption={false}
              disabled={!isEditMode}
              label="Game Types"
              options={gameTypeOptions}
              size="small"
              testId="game-types-dropdown"
              values={gameTypes}
              onChange={(selected) => {
                const selectedValues = selected.map((option) => option.value);
                setValue('gameTypes', selectedValues, { shouldDirty: true });
              }}
            />
          </StyledInput>
          <StyledInput
            error={errors.allowedStates?.message as string}
            label="Allowed States"
            name="allowedStates"
            readOnly={isReadOnly}
            register={register}
          >
            <MultiSelect
              allowSelectNone
              defaultEmpty
              allOption={false}
              disabled={!isEditMode}
              label="Allowed States"
              options={allowedStatesOptions}
              size="small"
              testId="allowed-states-dropdown"
              values={allowedStates}
              onChange={(selected) => {
                const selectedValues = selected.map((option) => option.value);
                setValue('allowedStates', selectedValues, {
                  shouldDirty: true
                });
              }}
            />
          </StyledInput>
        </StyledCard>
      </div>
    </form>
  );
};
